import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {featureKeyFiltro} from './feature-filtro.selectors';
import {featureFiltroRecucer} from './feature-filtro.reducer';
import {EffectsModule} from '@ngrx/effects';
import {FeatureFiltroEffects} from './feature-filtro.effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKeyFiltro, featureFiltroRecucer),
    EffectsModule.forFeature([FeatureFiltroEffects]),
  ],
})
export class FeatureFiltroModule {
}
